import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage, useField } from "formik";
import * as Yup from "yup";
import styles from "./feasibilityCheck.module.css";
import { Submit } from "../../../../components/button/buttons";
import IMAGES from "../../../../assets/images/images";
import { FormFieldLabel as Label, FormErrorLabel as ErrorLabel } from "../../../../components/label/Labels";
import Asterisk from "../../../../components/asterisk/Asterisk";
import FileUploadAttachment from "../../../../components/fileUpload/fileUpload.container"
import { useParams } from "react-router-dom";
import { DEMAND_ACTIONS } from "../../../../utils/constants/DemandConstant";

const ImageUpload = ({ setFieldValue, value, label, feasibility, data, ...props}) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  return (
    <div >
      <div style={{ display: "flex" }}><Label text={label} optional={false} /></div>
      <FileUploadAttachment
        setFieldValue={setFieldValue}
        name={props.name}
        value={value}
        note={false}
        displayMessage={"Upload limit: 1 file, up to 5 MB."}
        maxFileSize={5 * 1024 * 1024} //5MB
        maxFileSizeTXT={"5MB"}
        combineFilesMaxSize={5 * 1024 * 1024}
        combineFilesMaxSizeTXT={"Combined file size exceeds the 5MB limit"}
        numOfFilesAllowToUpload={1}
        errorMessageForNumberOfFiles={"You can upload max 1 file."}
        acceptFileType={
          {    
          'image/*': ['.jpeg','.png',],
          'application/pdf': ['.pdf'],
          'application/vnd.ms-excel': ['.xls',],
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':['.xlsx'],
          'application/msword':['.doc'],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document':['.docx']
          }
      }
      />
      {/* {hasError ? <ErrorLabel text={meta.error} /> : null} */}
    </div>
  );
};

const validationSchema = Yup.object({
  comment: Yup.string()
    .max(1000, "Comment must be at most 1000 characters")
    .test("comment-or-file", "Either comment or file is required", function (value) {
      const { files } = this.parent;
      return Boolean(value?.trim()) || (files?.length ?? 0) > 0;
    }),
  files: Yup.array(),
});

const FeasibilityForm = ({getServiceDetail, ...props}) => {
  const [isError, setisError] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
   let { requestId } = useParams();

  const SetError = (error) => {
    setisError(error)
  }

  return (
    <div className={styles.card}>
      <Formik
        initialValues={{ comment: "", files: [] }}
        validationSchema={validationSchema}
        validateOnMount
        onSubmit={async (values, helpers) => {
        const { resetForm } = helpers;
            setIsSubmit(true)
             const payload = {
                      action: DEMAND_ACTIONS.CPMPLETE_FEASIBILITY,
                      stateData: {
                          comment: values.comment,
                          files: values.files,
                      }
               }
               props.addDemandAction(payload, requestId, payload.action).then((result) => {
                 if (result) {
                   props.openAlertPopup({
                     message: "Feasibility assessment report has been uploaded successfully.",
                     image: IMAGES.success
                   });
                   setIsSubmit(false)
                   resetForm()
                   getServiceDetail(requestId);
                 } else {
                   let error_msg = result?.error?.message ?? "An error occurred while processing your request. Please try again later.";
                  setIsSubmit(false)
                   props.openAlertPopup({
                     message: error_msg,
                     image: IMAGES.error
                   });
                 }
               })
                 .catch((error) => {
                  setIsSubmit(false)
                   props.openAlertPopup({
                     message: "An error occurred while processing your request. Please try again later.",
                     image: IMAGES.error
                   });
                 });
        }}
      >
        {({ isValid,dirty, isSubmitting, errors, touched, setFieldValue, values }) => {
          return (
            <Form noValidate className={styles.form}>
              {/* <header className={styles.demandheader}>
                Feasibility Upload
                <img
                  className={styles.circleinfo}
                  src={IMAGES.infoCircle}
                  alt="Information icon"
                />
              </header> */}
              <div className={styles.fieldGroup}>
                <div className={styles.labelRow}>
                  <div className={styles.label} id="remarks-label">
                    Comment 
                  </div>
                </div>
                <Field
                  as="textarea"
                  name="comment"
                  className={styles.textarea}
                  rows={1}
                  placeholder="Type a message"
                />
                <div className={styles.errorwrapper}>
                <div className={styles.errorRow}>
                  <ErrorMessage name="comment">
                    {(msg) => <div className={styles.error}>{msg}</div>}
                  </ErrorMessage>
                </div>
                <div className={styles.commentValidation}>{`${values?.comment?.length}/1000 characters`}</div>
                </div>
              </div>
              <ImageUpload
                name="files"
                value={values.files}
                label="Supporting Attachments"
                setFieldValue={setFieldValue}
                optional={false}
                shoInlineError={false}
                feasibility={values.feasibility}
                isUploadReport={true}
                SetError={SetError}
              />
              {/* {isError && <div className={styles.fileSizeErrormsg}>{isError}</div>} */}
              <div className={styles.actions}>
                <Submit
                  type="submit"
                  disabled={isSubmitting || !(isValid && dirty)}
                  style={styles.submit}
                  isSubmitting={isSubmit}
                  title={"Submit"}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
      <div className={`${styles.moduledescription}  `}> <img className={styles.descriptioncircle} src={IMAGES.actionIcon} />Ensure the report does not include any customer PII or sensitive information that has not been approved for sharing.</div>
    </div>
  );
};

export default FeasibilityForm;